<template>
  <div :class="classes">
    <!-- Poster -->
    <slot v-if="!playing"/>
    <!-- Player -->
    <video
      ref="player"
      class="vertical"
      preload="none"
      webkit-playsinline="true" playsinline="true"
      width="100%" height="100%" frameborder="0"
      allow="autoplay"
      controlsList="nodownload"
      disablePictureInPicture
    >
      <source :src="mp4" type="video/mp4" />
      <!--Suportado em IE9, Chrome 6 e Safari 5 -->
      O seu navegador não suporta a tag vídeo
    </video>
  </div>
</template>

<script>
  export default {
    name: 'c-player',
    props: {
      mp4: {
        type: String,
        default: '/assets/images/niobi.mp4'
      },
      autoplay: {
        type: Boolean,
        default: false
      },
      loop: {
        type: Boolean,
        default: false
      },
      nocontrol: {
        type: Boolean,
        default: false
      },
      background: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        player: null,
        playing: false,
        loading: true,
        isBackgroundFluid: false
      }
    },
    created() {
      this.$on('clickbutton', this.onClickToPlay)

      window.addEventListener('resize', this.defineSizeBackground, false)
    },
    mounted() {
      this.player = this.construct(this.$refs.player)

      this.player.oncanplay = setTimeout(() => {
        this.loading = false

        if (this.background) {
          this.defineSizeBackground()
        }
      }, 0)
    },
    computed: {
      classes() {
        return [
          'c-player',
          { 'c-player--loading': this.loading },
          { 'c-player--background': this.background },
          { 'c-player--horizontal': this.isBackgroundFluid }
        ]
      }
    },
    methods: {
      construct(player) {
        player.loop = this.loop
        player.controls = !this.nocontrol

        if (this.autoplay || this.background) {
          player.autoplay = true
          player.muted = true
          player.play()

          this.playing = true
        }
        return player
      },
      onClickToPlay() {
        this.playing = true

        this.player.play()
      },
      defineSizeBackground() {
        const parent = this.$parent.$el
        const current = this.$refs.player

        if (this.isBackgroundFluid && parent.clientHeight > current.clientHeight) {
          this.isBackgroundFluid = false
        } else if (!this.isBackgroundFluid && parent.clientWidth > current.clientWidth) {
          this.isBackgroundFluid = true
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .c-player {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #000;
    overflow: hidden;
    visibility: visible;

    & video {
      display: block;
      width: 100%;
      height: 100%;
      outline: 0;

      &::-webkit-media-controls {
        visibility: hidden;
      }

      &::-webkit-media-controls-enclosure {
        visibility: visible;
      }
    }

    &--loading {
      visibility: hidden;
    }

    &--background {
      display: flex;
      align-items: center;
      justify-content: center;

      & video {
        overflow: hidden;
        position: absolute;
        right: 0;
        bottom: 0;
        width: auto;
        height: 100%;
        object-fit: cover;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
      }
    }

    &--horizontal {
      & video {
        width: 100%;
        height: auto;

      }
    }
  }
</style>


